<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

<div class="flex flex-col h-full">
  <div class="flex justify-between items-center mb-3">
    <h2 class="!m-0">{{ selectedNews.title }}</h2>

    <button mat-button color="primary" class="aup-action-button" [matMenuTriggerFor]="actions">
      {{ 'COMMON.ACTIONS' | transloco }}
      <mat-icon svgIcon="more" iconPositionEnd></mat-icon>
    </button>
    <mat-menu #actions="matMenu">
      @if (selectedNews.isReaded) {
        <button mat-menu-item (click)="onMarkAsUnread()">
          {{ 'NEWS.ACTIONS.MARK_AS_UNREAD' | transloco }}
        </button>
      }
      @if (!selectedNews.isReaded) {
        <button mat-menu-item (click)="onMarkAsRead()">
          {{ 'NEWS.ACTIONS.MARK_AS_READ' | transloco }}
        </button>
      }
    </mat-menu>
  </div>

  @if (!newsDetails) {
    <aup-inline-loader class="mt-4"></aup-inline-loader>
  }

  @if (newsDetails) {
    <div class="flex-grow overflow-y-auto prose">
      <div [innerHtml]="newsDetails.html"></div>
    </div>
  }
</div>
